import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updatePlanAndRateOverrideRule } from '../../../api/plan-and-rate-override-rules-api'
import type {
  PlanAndRateOverrideRuleResponseDto,
  UpdatePlanAndRateOverrideRuleRequestDto,
} from '../../../api/dto/plan-and-rate-override-rules.dto'
import { PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanAndRateOverride/hooks/useGetPlanAndRateOverrideRules'
import { PLAN_AND_RATE_OVERRIDE_RULE_QUERY_KEY } from './useGetPlanAndRateOverrideRule'

export function useUpdatePlanAndRateOverrideRule(id: string) {
  const queryClient = useQueryClient()

  return useMutation<
    PlanAndRateOverrideRuleResponseDto,
    unknown,
    UpdatePlanAndRateOverrideRuleRequestDto
  >({
    mutationFn: (body) => updatePlanAndRateOverrideRule(id, body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [PLAN_AND_RATE_OVERRIDE_RULE_QUERY_KEY, id],
      })
    },
  })
}
